export const PermissionsServiceTokens = Object.freeze({
    RouterAdapter: Symbol('RouterAdapter'),
    UserProfileProvider: Symbol('UserProfileProvider'),
    PermissionChecker: Symbol('PermissionChecker'),
} as const);
